<template>
  <div class="container py-5">
    <!-- 모바일 전용 페이지 체크 -->
    <div v-if="!isMobile" class="alert alert-warning mx-auto" style="max-width: 480px; text-align: center;">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <div class="fw-bold mt-2">결제 페이지는 모바일로만 접속 가능합니다</div>
      <div class="small mt-2">스마트폰의 웹 브라우저에서 접속해주세요.</div>
    </div>

    <div class="card shadow-lg mx-auto" style="max-width: 480px;" :style="{ display: isMobile ? 'block' : 'none' }">
      <div class="card-header bg-primary text-white text-center">
        <h3 class="mb-0">정기권 결제 요청</h3>
      </div>
      <div class="card-body">
        <div class="mb-4">
          <div v-if="areaInfo" class="d-flex justify-content-center mb-2">
            <span class="badge bg-secondary fs-6 px-3 py-2 shadow-sm">
              주차장: {{ areaInfo.name }}
            </span>
          </div>
          <div class="info-box bg-light rounded-3 p-3 mx-auto">
            <div class="info-row mb-2">
              <span class="info-label">차량번호</span>
              <span class="info-value">{{ parkingPassInfo?.CarNumber || carNum }}</span>
            </div>
            <div class="info-row mb-2">
              <span class="info-label">구매자명</span>
              <span class="info-value">{{ parkingPassInfo?.Name || BuyerName }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">연락처</span>
              <span class="info-value">{{ maskPhoneNumber(parkingPassInfo?.Tel || BuyerTel) }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">정기권 종류</span>
              <span class="info-value">{{ parkingPassInfo?.FeeName || (waitingUser && waitingUser.SEAREG_PAYCODE ? waitingUser.SEAREG_PAYCODE : '-') }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">주차장</span>
              <span class="info-value">{{ parkingPassInfo?.AreaName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">결제 상태</span>
              <span class="info-value">{{ paymentStatus || '-' }}</span>
            </div>
            <div v-if="paymentExpireDate" class="info-row">
              <span class="info-label">결제기한</span>
              <span class="info-value">{{ paymentExpireDate }}</span>
            </div>
            <div v-if="parkingPassInfo?.DiscountPrice && parkingPassInfo.DiscountPrice > 0" class="info-row">
              <span class="info-label">할인금액</span>
              <span class="info-value text-success fw-bold">-{{ parkingPassInfo.DiscountPrice.toLocaleString() }} 원</span>
            </div>
          </div>
        </div>

        <form id="tranMgr" name="tranMgr" method="post" @submit.prevent>
          <div class="mb-3">
            <label for="Amt" class="form-label fw-bold">결제 금액</label>
            <div class="display-amount fs-3 fw-bold py-2">
              {{ (parseInt(formData.Amt, 10) || 0).toLocaleString() }} 원
            </div>
            <div class="tax-info text-secondary small mb-2">
              <div>과세액: {{ taxInfo.taxAmt.toLocaleString() }} 원</div>
              <div>부가세: {{ taxInfo.vatAmt.toLocaleString() }} 원</div>
              <div>면세액: {{ taxInfo.taxFreeAmt.toLocaleString() }} 원</div>
            </div>
            <div v-if="paymentExpireDate" class="alert alert-light border border-warning text-warning small mb-2">
              <strong>결제기한 안내:</strong> {{ paymentExpireDate }}까지 결제하지 않으면 신청이 만료될 수 있습니다.
            </div>
            <div v-else class="alert alert-light border border-info text-info small mb-2">
              <strong>결제기한 안내:</strong> 결제 완료 전까지 정상 결제 가능하며, 기한 내 결제가 완료되지 않으면 신청이 만료될 수 있습니다.
            </div>
            <!-- SDK용 값은 hidden input으로 유지 (사용자가 수정 불가) -->
            <input type="hidden" id="Amt" name="Amt" v-model="formData.Amt" />
          </div>          
          <div class="mb-3">
            <label for="BuyerEmail" class="form-label">이메일 (선택)</label>
            <input type="email" class="form-control" id="BuyerEmail" name="BuyerEmail" v-model="formData.BuyerEmail" />
          </div>
          <!-- hidden input들은 그대로 -->
          <input type="hidden" name="PayMethod" v-model="formData.PayMethod"/>
          <input type="hidden" name="GoodsCnt" v-model="formData.GoodsCnt"/>
          <input type="hidden" name="GoodsName" v-model="formData.GoodsName"/>
          <input type="hidden" name="Moid" v-model="formData.Moid"/>
          <input type="hidden" name="Mid" v-model="formData.Mid"/>
          <input type="hidden" name="ReturnUrl" v-model="formData.ReturnUrl"/>
          <input type="hidden" name="StopUrl" v-model="formData.StopUrl"/>
          <input type="hidden" name="EncryptData" v-model="formData.EncryptData"/>
          <input type="hidden" name="EdiDate" v-model="formData.EdiDate"/>
          <input type="hidden" name="GoodsCl" v-model="formData.GoodsCl"/>
          <!-- 추가: SDK가 읽는 필드로 반드시 name을 맞춘 hidden Buyer 필드 -->
          <input type="hidden" name="BuyerName" v-model="formData.BuyerName" />
          <input type="hidden" name="BuyerTel" v-model="formData.BuyerTel" />
          <div v-if="isAlreadyPaid || isPaymentExpired" class="alert alert-warning mt-2">{{ paidMessage }}</div>
          <button type="button" class="btn btn-lg btn-primary w-100 mt-3" @click="handlePay" :disabled="isAlreadyPaid || isPaymentExpired">
            <i class="bi bi-credit-card"></i> 결제하기
          </button>
        </form>

      </div>
    </div>
    <!-- 결제 승인용 폼 (숨김) -->
    <!-- <form id="approvalForm" name="approvalForm" method="post" class="d-none">
      <input type="hidden" id="Tid" name="Tid"/>
      <input type="hidden" id="TrAuthKey" name="TrAuthKey"/>
    </form> -->

  <!-- 서버에 저장된 승인 응답 표시 영역 -->
  <div v-if="approvalResult" class="container mt-4">
    <div class="card mx-auto" style="max-width:720px;">
      <div class="card-header">결제 승인 응답 (서버 저장)</div>
      <div class="card-body">
        <pre style="white-space:pre-wrap;word-break:break-word">{{ JSON.stringify(approvalResult, null, 2) }}</pre>
      </div>
    </div>
  </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import CryptoJS from "crypto-js";

const SERVER_URL = process.env.VUE_APP_API_BASE;

const rawPayMode = String(process.env.VUE_APP_PAY_MODE || process.env.MODE || '').trim().toUpperCase();
const smartroMode = rawPayMode === 'REAL' ? 'REAL' : 'STG';

const isAlreadyPaid = ref(false);
const isPaymentExpired = ref(false);
const paidMessage = ref('');
const paymentStatus = ref('');
const paymentSeqId = ref(null);
const paymentExpireDate = ref('');
const isMobile = ref(true);
const scriptTag = ref(null);

function maskPhoneNumber(phone) {
  if (!phone) return '-';
  const phoneStr = String(phone).trim();
  if (phoneStr.length < 3) return phoneStr;
  // 뒤에서 2자리 마스킹
  return phoneStr.slice(0, -2) + '**';
}

function checkIsMobile() {
  const ua = navigator.userAgent.toLowerCase();
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(ua);
  const screenWidth = window.innerWidth;
  return isMobileUA || screenWidth <= 768;
}

function checkPaymentExpired(expireDateStr) {
  if (!expireDateStr) return false;
  const normalized = expireDateStr.length === 10 ? `${expireDateStr}T23:59:59` : expireDateStr;
  const expireDate = new Date(normalized);
  if (Number.isNaN(expireDate.getTime())) return false;
  return new Date() > expireDate;
}

function setPaymentLockState(status, seq, expireDate) {
  paymentStatus.value = String(status || '').trim().toUpperCase();
  paymentSeqId.value = seq || null;
  paymentExpireDate.value = expireDate || '';
  isPaymentExpired.value = checkPaymentExpired(expireDate);
  if (paymentStatus.value === 'PAID') {
    isAlreadyPaid.value = true;
    paidMessage.value = `이미 결제되었습니다 (PaymentSeq: ${paymentSeqId.value}).`;
  }
  if (isPaymentExpired.value && paymentStatus.value !== 'PAID') {
    paidMessage.value = `결제기한이 지났습니다. 결제를 진행할 수 없습니다.`;
  }
}

//실제 지축역 주차장 정보 (테스트용으로 대체 가능)
// const MID = "gycity206m";
// const MERCHANT_KEY = "EJnVnnLVZHzznq9yOO0vEoCn1gCte/ML/ooHa72ZDTL//urmHgEk4YznsYAOSF8Q+017jCJgc2mMnq3QEFVOVA==";


// base server (remove trailing slash if present)
const baseServer = (SERVER_URL || '').replace(/\/$/, '');

const route = useRoute();

// 개발/테스트 편의를 위한 기본값 (쿼리 파라미터가 없을 때 사용)
const carNum = route.query.carNum || "01가1234";
const BuyerName = route.query.BuyerName || "홍길동";
const BuyerTel = route.query.BuyerTel || "010-1234-5678";
let userSeq = parseInt(route.query.UserSeq || route.query.userSeq, 10) || 5;
// testUserSeq removed: paymentSeq is used instead

const waitingUser = ref(null);
const parkingPassInfo = ref(null);
const areaInfo = ref(null);
const paymentConfig = ref({
  MID: '',
  MerchantKey: '',
  CancelPwd: ''
});

const taxFreeAmt = 0;

const formData = reactive({
  PayMethod: "CARD",
  GoodsCnt: "1",
  GoodsName: carNum ? `정기권 결제(${carNum})` : "정기권 결제",
  Amt: "10",
  Moid: "Moid_" + Date.now(),
  Mid: '',
  ReturnUrl: baseServer + "/api_pay/successMobile",
  StopUrl: baseServer + "/api_pay/fail",
  BuyerName: BuyerName,
  BuyerTel: BuyerTel,
  BuyerEmail: "",
  EncryptData: "",
  EdiDate: "",
  GoodsCl: "0",
});

const taxInfo = computed(() => {
  const price = parseInt(formData.Amt, 10) || 0;
  const tmp = taxFreeAmt > 0 ? (price - taxFreeAmt) / 1.1 : price / 1.1;
  const vatAmt = Math.floor(price - tmp);
  const taxAmt = price - vatAmt - taxFreeAmt;
  return {
    price,
    taxAmt,
    vatAmt,
    taxFreeAmt
  };
});

function getyyyyMMddHHmmss() {
  const date = new Date();
  return (
    date.getFullYear().toString() +
    String(date.getMonth() + 1).padStart(2, "0") +
    String(date.getDate()).padStart(2, "0") +
    String(date.getHours()).padStart(2, "0") +
    String(date.getMinutes()).padStart(2, "0") +
    String(date.getSeconds()).padStart(2, "0")
  );
}

function encodeSHA256Base64(strPW) {
  const hash = CryptoJS.SHA256(strPW);
  return CryptoJS.enc.Base64.stringify(hash);
}

const setData = () => {
  return new Promise((resolve) => {
    if (!formData.Mid || !paymentConfig.value.MerchantKey) {
      alert('결제 설정 정보가 아직 준비되지 않았습니다.');
      resolve();
      return;
    }
    formData.EdiDate = getyyyyMMddHHmmss();
    formData.EncryptData = encodeSHA256Base64(
      formData.EdiDate + formData.Mid + formData.Amt + paymentConfig.value.MerchantKey
    );
    resolve();
  });
};

const goPay = async () => {
  await setData();
  if (!window.smartropay) return alert("SmartroPay SDK가 로드되지 않았습니다.");

  window.smartropay.init({ mode: smartroMode });
  
  window.smartropay.payment({
    FormId: "tranMgr",
  });    
};

// polling for server-side approval result
const approvalResult = ref(null);

const handlePay = () => {
  if (isAlreadyPaid.value || isPaymentExpired.value) {
    alert(paidMessage.value || '결제를 진행할 수 없습니다.');
    return;
  }
  goPay();
};

// helper: Parse datetime to YYYYMM format
function getYYYYMMFromDate(dateStr) {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return '';
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${yyyy}${mm}`;
  } catch (e) {
    console.error('[getYYYYMMFromDate] error:', e);
    return '';
  }
}

// loadParkingPass: accepts either a userSeq or a paymentSeq.
// If the given seq corresponds to a PaymentSeq, we fetch the payment
// to obtain WaitingSeq, then load the waiting info and build GoodsName
// as AreaSeq_UserSeq_CarNumber_WaitingSeq_PaymentSeq_YYYYMM.
async function loadParkingPass(seq) {
  if (!seq) return;

  // First, try treating seq as a PaymentSeq
  try {
    const pResp = await fetch(`${SERVER_URL}/api/payment-request/id/${seq}`);
    if (pResp.ok) {
        const p = await pResp.json();
        const status = String(p.Status || p.status || '').trim().toUpperCase();
        const expireDate = p.ExpireDate || p.expireDate || '';
        setPaymentLockState(status, p.PaymentSeq || p.paymentSeq, expireDate);
        formData.Amt = String(p.PaymentPrice || p.OriginalPrice || 0);
        // still attempt to load waiting info for display
        if (p && p.WaitingSeq) {
        try {
          const wRes = await fetch(`${SERVER_URL}/api/parking-pass-waiting/${p.WaitingSeq}`);
          if (wRes.ok) {
            const w = await wRes.json();
            parkingPassInfo.value = w;
            areaInfo.value = { name: w.AreaName };
            if (w.CarNumber && w.AreaSeq && w.WaitingSeq) {
              const lastPaidMonth = getYYYYMMFromDate(p.StartDate);
              formData.GoodsName = `${w.AreaSeq}_${w.UserSeq}_${w.CarNumber}_${w.WaitingSeq}_${p.PaymentSeq}_${lastPaidMonth}`;
            }
            if (w.Name) formData.BuyerName = w.Name;
            if (w.Tel) formData.BuyerTel = w.Tel;
            if (w.MID) {
              formData.Mid = w.MID;
              paymentConfig.value.MID = w.MID;
            }
            if (w.MerchantKey) paymentConfig.value.MerchantKey = w.MerchantKey;
            if (w.CancelPwd) paymentConfig.value.CancelPwd = w.CancelPwd;

            // Use payment record price when available
            formData.Amt = String(p.PaymentPrice || p.OriginalPrice || w.Price || 0);
            return;
          }
        } catch (e) {
          console.error('[PaymentView] Failed to load waiting info by paymentSeq', e);
          // fallthrough to userSeq flow
        }
      }
    }
  } catch (e) {
    console.warn('[PaymentView] paymentSeq lookup failed, will try userSeq:', e);
  }

  // Fallback: treat seq as a userSeq and load waiting info by user
  try {
    const res = await fetch(`${SERVER_URL}/api/parking-pass-waiting/user?userSeq=${seq}`);
    if (!res.ok) {
      throw new Error(`API error: ${res.status}`);
    }
    const data = await res.json();
    parkingPassInfo.value = data;
    areaInfo.value = { name: data.AreaName };
    if (data.CarNumber && data.AreaSeq && data.WaitingSeq) {
      formData.GoodsName = `${data.AreaSeq}_${seq}_${data.CarNumber}_${data.WaitingSeq}`;
    }
    if (data.Name) formData.BuyerName = data.Name;
    if (data.Tel) formData.BuyerTel = data.Tel;
    if (data.MID) {
      formData.Mid = data.MID;
      paymentConfig.value.MID = data.MID;
    }
    if (data.MerchantKey) paymentConfig.value.MerchantKey = data.MerchantKey;
    if (data.CancelPwd) paymentConfig.value.CancelPwd = data.CancelPwd;

    // ParkingPaymentRequest 테이블에서 paymentPrice 조회
    if (data.WaitingSeq) {
      try {
        const paymentRes = await fetch(`${SERVER_URL}/api/payment-request/${data.WaitingSeq}`);
        if (paymentRes.ok) {
          const paymentData = await paymentRes.json();
          const paymentDataStatus = String(paymentData.Status || '').trim().toUpperCase();
          paymentStatus.value = paymentDataStatus || paymentStatus.value || '';
          paymentSeqId.value = paymentData.PaymentSeq || paymentSeqId.value || null;
          // if payment is already PAID, lock UI
          if (paymentData && paymentDataStatus === 'PAID') {
            isAlreadyPaid.value = true;
            paidMessage.value = `이미 결제되었습니다 (PaymentSeq: ${paymentData.PaymentSeq}).`;
            formData.Amt = String(paymentData.PaymentPrice || paymentData.OriginalPrice || 0);
          } else {
            formData.Amt = String(paymentData.PaymentPrice || 0);
            if (paymentData.PaymentSeq && data.CarNumber && data.AreaSeq && data.WaitingSeq) {
              const lastPaidMonth = getYYYYMMFromDate(paymentData.StartDate);
              formData.GoodsName = `${data.AreaSeq}_${seq}_${data.CarNumber}_${data.WaitingSeq}_${paymentData.PaymentSeq}_${lastPaidMonth}`;
            }
          }
          console.log('[PaymentView] Payment price loaded:', paymentData.PaymentPrice);
        } else {
          console.warn('[PaymentView] No payment request found, using data.Price');
          formData.Amt = String(data.Price || 0);
        }
      } catch (e) {
        console.error('[PaymentView] Failed to load payment price:', e);
        formData.Amt = String(data.Price || 0);
      }
    } else {
      formData.Amt = String(data.Price || 0);
    }
  } catch (e) {
    console.error('[PaymentView] Failed to load parking pass info', e);
  }
}

onMounted(async () => {
  // 모바일 체크
  isMobile.value = checkIsMobile();

  // SmartroPay SDK 동적 로드 (모바일에서만)
  if (isMobile.value) {
    const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    const script = document.createElement("script");
    script.src = smartroMode === 'STG'
      ? `https://tmpay.smartropay.co.kr/asset/js/SmartroPAY-1.0.min.js?version=${today}` // 모바일 테스트
      : `https://mpay.smartropay.co.kr/asset/js/SmartroPAY-1.0.min.js?version=${today}`; // 실제 운영
    
    document.head.appendChild(script);
    scriptTag.value = script;
  }

  // 초기 로드: paymentSeq 우선, 없으면 userSeq 사용
  const paymentSeq = route.query.paymentSeq || route.query.PaymentSeq || route.query.paymentseq;
  if (paymentSeq) {
    try {
      const resp = await fetch(`${SERVER_URL}/api/payment-request/id/${paymentSeq}`);
      if (resp.ok) {
        const p = await resp.json();
        const status = String(p.Status || p.status || '').trim().toUpperCase();
        paymentStatus.value = status;
        paymentSeqId.value = p.PaymentSeq || p.paymentSeq || null;
        if (status === 'PAID') {
          isAlreadyPaid.value = true;
          paidMessage.value = `이미 결제되었습니다 (PaymentSeq: ${paymentSeqId.value}).`;
        }
        formData.Amt = String(p.PaymentPrice || p.OriginalPrice || 0);
        // if waitingSeq present, load waiting details for display
        if (p.WaitingSeq) {
          try {
            const wRes = await fetch(`${SERVER_URL}/api/parking-pass-waiting/${p.WaitingSeq}`);
            if (wRes.ok) {
              const w = await wRes.json();
              parkingPassInfo.value = w;
              areaInfo.value = { name: w.AreaName };
              if (w.CarNumber && w.AreaSeq && w.WaitingSeq) {
                const lastPaidMonth = getYYYYMMFromDate(p.StartDate);
                formData.GoodsName = `${w.AreaSeq}_${w.UserSeq}_${w.CarNumber}_${w.WaitingSeq}_${p.PaymentSeq}_${lastPaidMonth}`;
              }
              if (w.Name) formData.BuyerName = w.Name;
              if (w.Tel) formData.BuyerTel = w.Tel;
              // Ensure MID and MerchantKey are applied to formData/paymentConfig
              if (w.MID) {
                formData.Mid = w.MID;
                paymentConfig.value.MID = w.MID;
              }
              if (w.MerchantKey) {
                paymentConfig.value.MerchantKey = w.MerchantKey;
              }
              if (w.CancelPwd) {
                paymentConfig.value.CancelPwd = w.CancelPwd;
              }
            }
          } catch (e) {
            console.error('[PaymentView] Failed to load waiting info by paymentSeq', e);
          }
        }
      } else {
        // fallback to userSeq flow
        await loadParkingPass(userSeq);
      }
    } catch (e) {
      console.error('[PaymentView] error loading by paymentSeq', e);
      await loadParkingPass(userSeq);
    }
  } else {
    // 기본 userSeq 흐름
    await loadParkingPass(userSeq);
  }
});

onBeforeUnmount(() => {
  if (scriptTag.value && scriptTag.value.parentNode) {
    try {
      document.head.removeChild(scriptTag.value);
    } catch (e) {
      // script already removed
    }
  }
});

// applyTestUserSeq removed: no manual userSeq loading needed when using paymentSeq
</script>

<style scoped>
.container {
  background: #f8fafc;
  min-height: 100vh;
}
.card {
  border-radius: 1.2rem;
  border: none;
}
.card-header {
  border-radius: 1.2rem 1.2rem 0 0;
  font-size: 1.3rem;
  letter-spacing: 1px;
}
.display-amount {
  color: #e74c3c;
}
.tax-info {
  background: #f0f0f0;
  padding: 8px 12px;
  border-radius: 6px;
}
.info-box {
  max-width: 380px;
}
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-label {
  font-weight: 600;
  color: #333;
  min-width: 100px;
}
.info-value {
  text-align: right;
  color: #555;
}
</style>
